var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getKeys, siteIDs } from '../../adapters/utils';
import { get } from '../../utils/get';
import { SD_STATUS } from '../../consts';
import { getData } from './get-data';
import { getDataLegacy } from './get-data-legacy';
import { getUrlParts } from '../../utils/get-url-parts';
import { trimTrailingSlash } from '../../utils/trim-trailing-slash';
import { getRawImageObject } from '../../adapters/get-raw-image-object';
import { getItemsSdStatus } from '../utils';
export var IDs = {
    ID: 'challenge.id',
    AVAILABILITY: 'challenge.registration.availability',
    MAIN_IMAGE: 'challenge.mainImage',
    CALCULATED_ROBOTS: 'challenge.robots',
    CREATED_DATE: 'challenge.created',
    CURRENCY: 'challenge.registration.currency',
    DESCRIPTION: 'challenge.description',
    DESCRIPTION_150: 'challenge.description.150',
    IMAGE_HEIGHT: 'challenge.mainImage.height',
    IMAGE_ID: 'challenge.mainImage.id',
    IMAGE_WIDTH: 'challenge.mainImage.width',
    IMAGE_ALT: 'challenge.mainImage.alt',
    TITLE: 'challenge.name',
    CALCULATED_NAME: 'challenge.accessible.name',
    PRICE: 'challenge.registration.price',
    PAGE_URL: 'challenge.url',
    SD_JSON_IMAGES: 'challenge.structured-data.images',
    DISABLE_IMAGES_SCHEMA: 'challenge.images-schema.disable',
    IMAGES_SD_STATUS: 'challenge.structured-data.images-status',
    SD_JSON_VIDEOS: 'challenge.structured-data.videos',
    DISABLE_VIDEOS_SCHEMA: 'challenge.videos-schema.disable',
    VIDEOS_SD_STATUS: 'challenge.structured-data.videos-status',
    MEDIA_ITEMS: 'challenge.media',
};
var userVisible = [
    IDs.CALCULATED_NAME,
    IDs.DESCRIPTION_150,
    IDs.PRICE,
    IDs.PAGE_URL,
    IDs.MAIN_IMAGE,
    IDs.TITLE,
];
var userVisibleSdOnly = [
    IDs.IMAGE_WIDTH,
    IDs.IMAGE_HEIGHT,
    IDs.IMAGE_ALT,
    IDs.SD_JSON_IMAGES,
    // IDs.SD_JSON_VIDEOS,
];
var requiredSchemaVariables = [siteIDs.SITE_NAME, siteIDs.BUSINESS_NAME];
var SchemaTypes = {
    CHALLENGES_PAGE: 'challenges-page-preset',
    CHALLENGE_IMAGES: 'challenge-images',
    CHALLENGE_VIDEOS: 'challenge-videos',
};
var getFullUrl = function (item) {
    if (!item.program) {
        return get(item, 'challenge.url');
    }
    var base = trimTrailingSlash(get(item, 'program.settings.seo.url.base'));
    var path = get(item, 'program.settings.seo.url.path');
    return base.concat(path);
};
var getSdStatus = function (item, data, schemaType) {
    if (schemaType === SchemaTypes.CHALLENGE_IMAGES) {
        return data[IDs.IMAGES_SD_STATUS];
    }
    else if (schemaType === SchemaTypes.CHALLENGE_VIDEOS) {
        return data[IDs.VIDEOS_SD_STATUS];
    }
    return SD_STATUS.ENABLED;
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        var data = (item === null || item === void 0 ? void 0 : item.program) ? getData(IDs, item) : getDataLegacy(IDs, item);
        var imagesData = data[IDs.IMAGE_ID]
            ? [
                {
                    url: data[IDs.MAIN_IMAGE],
                    width: data[IDs.IMAGE_WIDTH],
                    height: data[IDs.IMAGE_HEIGHT],
                    name: data[IDs.IMAGE_ALT],
                },
            ]
            : [];
        var _b = getRawImageObject('images', imagesData).images, images = _b === void 0 ? '' : _b;
        var imagesSdStatus = getItemsSdStatus(imagesData, images);
        data[IDs.MEDIA_ITEMS] = imagesData.map(function (image) {
            return {
                image: image,
            };
        });
        data[IDs.SD_JSON_IMAGES] = images;
        return __assign(__assign({}, data), (_a = {}, _a[IDs.DISABLE_IMAGES_SCHEMA] = imagesSdStatus !== SD_STATUS.ENABLED, _a[IDs.IMAGES_SD_STATUS] = imagesSdStatus, _a));
    },
    getSdStatus: getSdStatus,
    getSlug: function (item) {
        return (item === null || item === void 0 ? void 0 : item.program)
            ? get(item, 'program.settings.seo.slug')
            : get(item, 'challenge.slug');
    },
    getFullUrl: getFullUrl,
    setFullUrl: function (item, url) {
        if (url === void 0) { url = ''; }
        item = JSON.parse(JSON.stringify(item));
        if (item === null || item === void 0 ? void 0 : item.program) {
            var _a = getUrlParts(url), base = _a.base, path = _a.path;
            item.program.settings.seo.url = {
                base: base,
                path: path,
            };
            return item;
        }
        else {
            item.challenge.url = url;
            return item;
        }
    },
    updateItemDataWithSlug: function (itemData, slugValue) {
        if (!(itemData === null || itemData === void 0 ? void 0 : itemData.program)) {
            return itemData;
        }
        var updatedItemData = JSON.parse(JSON.stringify(itemData));
        if (get(updatedItemData, 'program.settings.seo.slug') !== '') {
            updatedItemData.program.settings.seo.slug = slugValue;
        }
        return updatedItemData;
    },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
};
